module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm._elTag, {
    tag: "div",
    staticClass: "el-radio-group",
    attrs: {
      "role": "radiogroup"
    },
    on: {
      "keydown": _vm.handleKeydown
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64aefa6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/radio/src/radio-group.vue
// module id = 2164
// module chunks = 137